import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-setting-player-level-form',
  templateUrl: './setting-player-level-form.component.html',
  styleUrls: ['./setting-player-level-form.component.scss']
})
export class SettingPlayerLevelFormComponent {

  @ViewChild("f", {static: true}) f:NgForm;

  public data:any = {
    title: '',
    promotion_audience: 'all',
    status: "1"
  };

  public player_levels:any = [];

  metricLabel() {
    switch (this.data.upgrade_player_level) {
      case 'by-deposit':
        return 'Deposit';
      case 'by-lose':
        return 'Lose';
      case 'by-turnover':
      default:
        return 'Turnover';
    }
  }

  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      if(params['uuid']) {
        this.init(params['uuid']);
      }
    });
  }

  async init(uuid = null) {
    this.player_levels = await this.http.post('/admin/setting/player-level/get');
    if(!uuid) {
      return
    }
    this.data = await this.http.post('/admin/setting/player-level/get', {uuid: uuid});
    this.data.promotion_audience = this.data.promotion_audience || 'all';
    console.log(this.data)
  }

  async submit() {

    if(this.f.invalid) {
      console.log(this.f)
      return;
    }

    const s = await this.http.post("/admin/setting/player-level/update", this.data)

    if (s['status']) {
      this.http.notify("Player level update successfully.")
      this.http.naviBack();
    }
  }

}
